export default __webpack_public_path__ + "static/media/480_store05-en-mobile.16604dde.png";